import axios from "axios";
import { store } from "@/store/store";

const baseurl = process.env.VUE_APP_AWS_COGNITO_REDIRECT_URL

const lambdahttp = axios.create({
  baseURL: baseurl,
  headers: {
    "Content-Type": "application/json",
  },
});

lambdahttp.interceptors.request.use((config:any) => {
  if (config.headers != undefined) {
    config.headers.Authorization = store.getters.idToken;
  }
  return config;
});

export default lambdahttp;